import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import { getCurrentUser } from "vuefire";

function lazyView(view: string) {
  return () => import(`../pages/${view}.vue`);
}

const DashboardPage = () => import("../pages/DashboardPage.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/sign-up",
    name: "SignUpPage",
    component: lazyView("SignUpPage"),
  },
  {
    path: "/payment",
    name: "PaymentPage",
    component: lazyView("PaymentPage"),
  },
  {
    path: "/scf",
    name: "SupplyChainPage",
    component: lazyView("SupplyChainPage"),
  },
  {
    path: "/",
    name: "Intro",
    component: DashboardPage,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "home-redirect",
        redirect: (_to) => ({ name: "WithdrawalPage" }),
      },
      {
        path: "dashboard",
        name: "WithdrawalPage",
        component: lazyView("WithdrawalPage"),
      },
      {
        path: "withdraw",
        name: "InitiateWithdrawalPage",
        component: lazyView("InitiateWithdrawalPage"),
      },
      {
        path: "application",
        name: "WithdrawalApplicationPage",
        component: lazyView("WithdrawalApplicationPage"),
      },
      {
        path: "summary",
        name: "ApplicationSummaryPage",
        component: lazyView("ApplicationSummaryPage"),
      },
    ],

    // children: [
    //   {
    //     path: "dashboard",
    //     name: "HomePage",
    //     component: lazyView("HomePage"),
    //   },
    // ],
  },
  {
    path: "/login",
    name: "LoginPage",
    component: lazyView("LoginWithEmailPage"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  // routes with `meta: { requiresAuth: true }` will check for
  // the users, others won't
  if (to.meta.requiresAuth) {
    const currentUser = await getCurrentUser();
    // if the user is not logged in, redirect to the login page
    if (!currentUser) {
      return {
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      };
    }
  }
});

export default router;
